import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material/icon';
import {Injectable} from '@angular/core';

/**
 * @deprecated Use IconService from @LV1871/core; register SVG-Icons in lib-core/icons
 */
@Injectable()
export class SvgIconService {
  constructor(private _matIconRegistry: MatIconRegistry, private _domSanitizer: DomSanitizer) {
  }

  public init(path: string): void {
    let assetsPath = 'assets/';
    if (path) {
      assetsPath = path;
    }
    this._matIconRegistry.addSvgIcon('flugsport', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'flugsport.svg'));
    this._matIconRegistry.addSvgIcon('bergsport', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'bergsport.svg'));
    this._matIconRegistry.addSvgIcon('kampfsport', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'kampfsport.svg'));
    this._matIconRegistry.addSvgIcon('mannschaftssport',
      this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'mannschaftssport.svg'));
    this._matIconRegistry.addSvgIcon('motorradsport', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'motorradsport.svg'));
    this._matIconRegistry.addSvgIcon('reitsport', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'reitsport.svg'));
    this._matIconRegistry.addSvgIcon('sonstigeSportarten',
      this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'sonstigeSportarten.svg'));
    this._matIconRegistry.addSvgIcon('tauchsport', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'tauchsport.svg'));
    this._matIconRegistry.addSvgIcon('wassersport', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'wassersport.svg'));
    this._matIconRegistry.addSvgIcon('automobilsport',
      this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'automobilsport.svg'));
    this._matIconRegistry.addSvgIcon('check', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'check.svg'));
    this._matIconRegistry.addSvgIcon('checkCircle', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'check-circle.svg'));
    this._matIconRegistry.addSvgIcon('exclamationMark',
      this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'exclamation-triangle.svg'));
    this._matIconRegistry.addSvgIcon('pencil', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'pencil.svg'));
    this._matIconRegistry.addSvgIcon('trash', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'trash-alt.svg'));
    this._matIconRegistry.addSvgIcon('times', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'times.svg'));
    this._matIconRegistry.addSvgIcon('info', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'info-circle.svg'));
    this._matIconRegistry.addSvgIcon('phone', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'phone.svg'));
    this._matIconRegistry.addSvgIcon('download', this._domSanitizer.bypassSecurityTrustResourceUrl(assetsPath + 'file-download.svg'));
  }
}
